import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';
import { MEDIA_QUERY, SPACING } from '@zola/zola-ui/src/styles/emotion';

export const Container = styled.div`
  overflow-x: hidden;
  padding: ${SPACING.S24} ${SPACING.S24} 0;
  ${MEDIA_QUERY.TABLET} {
    padding: ${SPACING.LG} ${SPACING.S32} 0;
  }
  ${MEDIA_QUERY.DESKTOP} {
    padding: ${SPACING.LG} ${SPACING.LG} 0;
  }
`;

const scrolling = keyframes`
  0% { transform: translateX(0); }
  100% {
    transform: translateX(-50%);
  }
`;

export const Image = styled.img`
  border-radius: 16px;
`;

export const Marquee = styled.div`
  display: flex;
  align-items: center;
  gap: 26px;
  width: fit-content;
  animation: ${scrolling} 60s linear infinite;
  ${MEDIA_QUERY.MOBILE} {
    animation: ${scrolling} 50s linear infinite;
  }
`;
